import { Project } from '../../../team-apis/otterdam/project';
import { Task } from '../../../team-apis/otterdam/task';
import { CustomJS } from '../custom-js';
import { OutputInfoByName } from './output-info';

export class H3mlState {
  project!: Project;
  outputInfoByName!: OutputInfoByName;
  layout!: string;
  customJs?: CustomJS;
  readOnly = false;
  task!: Task;
}
